import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center py-2 border-b last:border-b-0"
};
const _hoisted_2 = {
  class: "flex flex-col grow mr-2"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = {
  class: "flex-1"
};
const _hoisted_5 = {
  class: "flex-1"
};
import Gate from "@/modules/action-points/components/Gate.vue";
import { PositionAreaEnum } from "@/modules/base/enums";
import { TrainingEvaluator } from "@/modules/training/services/TrainingEvaluator";
import { app } from "@/di";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import PlayerComponent from "@/modules/team/components/Player.vue";
import PlayerEnergy from "@/modules/team/components/PlayerEnergy.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingPlayerItem',
  props: {
    player: null
  },
  emits: ['trained'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const trainingEvaluator = app.get(TrainingEvaluator);
    const canTrain = computed(() => trainingEvaluator.can(props.player));
    const progress = computed(() => props.player.skill - Math.floor(props.player.skill));
    const cost = computed(() => app.get(ConfigRepository).get('training.actionPointsCosts'));
    const gateType = computed(() => ({
      [PositionAreaEnum.GK]: GateTypeEnum.TRAINING_GK,
      [PositionAreaEnum.DF]: GateTypeEnum.TRAINING_DF,
      [PositionAreaEnum.MF]: GateTypeEnum.TRAINING_MF,
      [PositionAreaEnum.AT]: GateTypeEnum.TRAINING_AT
    })[props.player.positionArea]);
    const onTrain = async commit => {
      await trainingEvaluator.evaluate(props.player);
      await commit();
      await emit('trained');
    };
    return (_ctx, _cache) => {
      const _component_NProgress = _resolveComponent("NProgress");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(PlayerComponent, {
        player: __props.player,
        "show-talent": "",
        "hide-constitution": ""
      }, null, 8, ["player"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(PlayerEnergy, {
        player: __props.player,
        type: "progress",
        class: "mr-0.5"
      }, null, 8, ["player"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_NProgress, {
        percentage: _unref(progress) * 100,
        "show-indicator": false,
        class: "ml-0.5"
      }, null, 8, ["percentage"])])])]), _createElementVNode("div", null, [_createVNode(Gate, {
        type: _unref(gateType),
        value: _unref(cost),
        "no-confirm": "",
        disabled: !_unref(canTrain),
        onAction: onTrain
      }, null, 8, ["type", "value", "disabled"])])]);
    };
  }
});